import { useEffect, useState } from "react";
import LoadingWheel from "../shared/LoadingWheel";
import ComboBoxInput from "../shared/Inputs/ComboBoxInput";

import useCategories from "../../data/Category/useCategories";
import { IPartCategory } from "../../models/Category/Category";

import { useSearchParams } from 'react-router-dom';

export default function CategorySelect({
    register,
    registerName = "category",
    setValue,
    initialValue,
    label,
}: {
    register: any;
    registerName?: string;
    setValue: any;
    initialValue?: string;
    label?: string;
}){
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const { categories: allCategories } = useCategories({
        itemsPerPage: 5000
    });
    const [categories, setCategories] = useState<IPartCategory[]>();

    const [searchParams] = useSearchParams();

    useEffect(() => {
        if (allCategories.isLoading || !allCategories.data) return;

        setCategories(allCategories.data);
        setIsLoading(false);
    }, [allCategories.isLoading, allCategories.data, searchParams]);

    if (isLoading) return  <LoadingWheel />

    return (
        <ComboBoxInput
            label={label}
            options={categories}
            register={register}
            searchField={"name"}
            registerName={registerName}
            setValue={setValue}
            initialValue={searchParams.get("categoryId") ?? initialValue}
        />
    )
}